import * as _ from 'lodash';
import { SortingGroup } from './sortHelper';

angular.module("tromanWeb").factory('sortDialog', ['$parse', '$uibModal', 'tromanServer', 'isTroman', function ($parse, $uibModal, tromanServer, isTroman) {

    var so = {};

    function Property(expr, title) {
        this.expr = expr;
        this.fn = $parse(expr);
        this.title = title;
    }

    const partyDefinition = {
        title: isTroman ? 'Ändra sortering - Partier' : 'Ändra sortering - Kategorier',
        sortingProperty: new Property('SortingCode', 'Sortering'),
        properties: [
            new Property('Abbreviation', isTroman ? 'Partibeteckning' : "Förkortning"),
            new Property('Name', 'Namn')
        ]
    };

    const organizationDefinition = {
        title: 'Ändra sortering - Organisationer',
        sortingProperty: new Property('SortingCode', 'Sortering'),
        properties: [
            new Property('OrganizationType.Name', 'Org.Typ'),
            new Property('OrganizationType.SortingCode', 'Org.Typ Sortering'),
            new Property('Abbreviation', 'Förkortning'),
            new Property('Name', 'Namn')
        ]
    };

    const divisionDefinition = {
        title: 'Ändra sortering - Valkretsar',
        sortingProperty: new Property('SortingCode', 'Sortering'),
        properties: [
            new Property('Abbreviation', 'Förkortning'),
            new Property('Name', 'Namn')
        ]
    };

    const organizationTypeDefinition = {
        title: 'Ändra sortering - Organisationstyper',
        sortingProperty: new Property('SortingCode', 'Sortering'),
        properties: [
            new Property('Name', 'Namn')
        ]
    };

    function showSorter(listPromise, definition, endpoint) {

        var sp = {
            listPromise: listPromise,
            definition: definition,
            updateSorting: x => endpoint.updateSorting(x),
        };

        return $uibModal.open({
            animation: true,
            template: require('./sorter.html'),
            controller: 'SorterController as sc',
            windowClass: "modal fade in",
            size: 'lg',
            resolve: {
                sorterParams: function () { return sp; }
            }
        }).result;
    }

    so.sortParties = function sortParties(listPromise) {
        return showSorter(listPromise, partyDefinition, tromanServer.Parties);
    };

    so.sortOrganizations = function sortOrganizations(listPromise) {
        return showSorter(listPromise, organizationDefinition, tromanServer.Organizations);
    };

    so.sortDivisions = function sortDivisions(listPromise) {
        return showSorter(listPromise, divisionDefinition, tromanServer.Divisions);
    };

    so.sortOrganizationTypes = function sortOrganizationTypes(listPromise) {
        return showSorter(listPromise, organizationTypeDefinition, tromanServer.OrganizationTypes);
    };

    /**
     *
     * @param {SortingGroup[]} groups
     */
    function groupsToSortUpdate(groups) {
        return _.flatMap(groups, (group, index) => {
            return _.map(group.items, item => ({
                Id: item.Id,
                RowVersion: item.RowVersion,
                SortingCode: index + 1,
            }));
        });
    }

    so.sortMissions = function sortMissions(listPromise, mandatePeriod) {
        function getGroups(missions) {
            var grouped = _.groupBy(missions, x => x.OrderNumber);
            return _.map(grouped, gms => {
                var real = _.filter(gms, x => !x.isPlaceholder());
                if (real.length === 0) {
                    return new SortingGroup(gms[0].OrderNumber, [], 'Ledigt ordningsnummer');
                }
                return new SortingGroup(gms[0].OrderNumber, real);
            });
        }

        var sp = {
            listPromise: listPromise.then(getGroups),
            definition: {
                placeholder: 'Ledigt ordningsnummer',
                properties: [
                    new Property('MissionType.Name', 'Uppdragstyp'),
                    new Property('Person != null ? Person.name : "(Vakant)"', 'Namn'),
                    new Property('Party.Abbreviation', isTroman ? 'Parti (Uppdrag)' : 'Kategori (Uppdrag)'),
                    new Property("Start | ergoDate", 'Start'),
                    new Property("End | ergoDate", 'Slut')
                ],
            },
            title: 'Ändra ordningsnummer - ' + mandatePeriod.Organization.Name,
            updateSorting: groups => tromanServer.Missions.updateSorting({
                MandatePeriodId: mandatePeriod.Id,
                Missions: groupsToSortUpdate(groups),
            }),
        };

        return $uibModal.open({
            animation: true,
            template: require('./sorter.missions.html'),
            controller: 'GroupSortController as sc',
            windowClass: "modal fade in",
            size: 'lg',
            resolve: {
                sorterParams: function () { return sp; }
            }
        }).result;
    };

    return so;

}]);